import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconSuggestionLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.002 13.77h9.963c1.157 0 2.14-.401 2.95-1.203.809-.8 1.214-1.778 1.214-2.932s-.405-2.132-1.215-2.933c-.81-.801-1.792-1.202-2.949-1.202a.725.725 0 0 0-.534.216.726.726 0 0 0-.216.534c0 .213.072.391.216.535a.725.725 0 0 0 .534.215 2.59 2.59 0 0 1 1.886.764c.518.51.778 1.134.778 1.872a2.52 2.52 0 0 1-.778 1.87 2.592 2.592 0 0 1-1.886.763H6.002L9.184 9.1a.729.729 0 0 0 .223-.52.692.692 0 0 0-.22-.536.723.723 0 0 0-.526-.206.7.7 0 0 0-.52.208l-4.37 4.331a.88.88 0 0 0-.271.639c0 .243.09.455.271.636l4.37 4.33c.148.15.322.22.521.215a.756.756 0 0 0 .522-.23.76.76 0 0 0 .225-.527.68.68 0 0 0-.225-.527L6.002 13.77Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconSuggestionLine;
